import { Toast, ToastProps } from "@vesatogo/grass-core"
import toast, { ToastOptions } from "react-hot-toast"

export type CustomToastProps = ToastProps & ToastOptions

export const CustomToast = ({ ...props }: CustomToastProps) => {
  return toast.custom(<Toast {...props} />)
}
